import React, { useState, useEffect } from "react";
import Pdf from "./Pdf";

export default function ResumenTemporada() {
    return (
        <>
            <Pdf src="./assets/files/ciclones/resumen-temporada/2021.pdf" />
        </>
    );
}